Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "YouTube", {
  enumerable: true,
  get: function get() {
    return _youtube.YouTube;
  }
});
var _youtube = require("./youtube");